
/*
 * IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA
 * GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT
 *
 * Copyright: 2023 by Idemia Identity & Security USA LLC. All rights reserved.
 * License: In accordance  Idemia I&S USA LLC's license agreement.
 * Code Classification: GOVERNMENT
 *
 * Classification Person: Nadim Bakizada nadim.bakizada@us.idemia.com
 * Classification Reason: Software not specific to any U.S. Government Entity
 * Classification Date: 2023
 *
 * GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT
 * IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA
 */

import React, { useEffect, useState } from "react";
import { urls } from '../urls'
import { formatDate } from "utils/formatDate";
import { transformRejectData } from "../utils";
import { transactionSummaryStore } from "state/TransactionSummaryStore"
import { useStore } from "zustand";

export const useResultsResponse = (registrationId: string) => {
    const [resultsResponse, setResultsResponse] = React.useState<any>();
    const [rejectData, setRejectData] = useState<any>([])
    const loadingRejectCodes = useStore(transactionSummaryStore, (state: any) => state.loadingRejectCodes)
    const setLoadingRejectCodes = useStore(transactionSummaryStore, (state: any) => state.setLoadingRejectCodes)
    const [totalRejectCodes, setTotalRejectCodes] = useState(0)
    const adjudicationUrl = urls.ADJUDICATION
    const personUrl = urls.PERSON;

    useEffect(() => {


        let fetchAdjudicationUrl = `${process.env.NODE_ENV === 'production' ? adjudicationUrl : ""}/adjudication/association/${registrationId}`;

        const getAssociations = (): Promise<[]> => {
            const controller = new AbortController();
            const { signal } = controller;
            return new Promise<[]>((resolve) => {
                (async () => {
                    const { associations } = await (await fetch(fetchAdjudicationUrl, {
                        credentials: "include",
                        signal
                    })).json();
                    resolve(associations)
                })()
            })


        }

        getAssociations().then((associations) => {
            if (associations.length) {
                fetchUrls(associations);
                fetchRejectCodes(associations)
            } else {
                setRejectData([])
                setTotalRejectCodes(0)
            }
        })

        const fetchUrls = async (associations) => {
            const controller = new AbortController();
            const { signal } = controller;
            try {
                const resultsResponses: Object[] = [];

                console.log('debug skeleton loading loadingRejectCodes click results associations: ', associations)

                if (associations.length) {
                    associations.filter((association: any) => association['type'] === 'Response').map(async (repAssociation: any) => {
                        let fetchingPersonUrl = `${process.env.NODE_ENV === 'production' ? personUrl : ""}/registration/${repAssociation.id}`;

                        const data = await (await fetch(fetchingPersonUrl, {
                            credentials: "include",
                            signal
                        })).json();

                        console.log('debug skeleton loading loadingRejectCodes click results associations data: ', { data, forId: repAssociation.id })

                        if (data) {
                            const { descriptors } = data;
                            let type2Field59;
                            if (descriptors.data.type1.field4 !== 'APP' && (descriptors.data.type2.field59 === undefined || descriptors.data.type2.field59 === '')) {
                                type2Field59 = descriptors.data.type1.field4
                            } else {
                                type2Field59 = descriptors.data.type2.field59?.toUpperCase();
                            }
                            const type1Field7 = descriptors.data.type1.field7?.toUpperCase();
                            const date = formatDate(descriptors.data.type1.field5);
                            type2Field59 && resultsResponses.push({ type2Field59, date, type1Field7 });
                        }
                    });
                    setResultsResponse(resultsResponses);
                    console.log('resultsResponses', resultsResponses)
                } else {
                    setRejectData([])
                    setTotalRejectCodes(0)
                }


            } catch (err: any) {
                console.log('ERROR => ', err);
            }
        }

        const fetchRejectCodes = async (associations) => {
            const controller = new AbortController();
            const { signal } = controller;
            try {

                setLoadingRejectCodes(true)
                let mostRecentResponse = associations.findLast(association => association.type === "Response")

                if (mostRecentResponse) {

                    let fetchingPersonUrl = `${process.env.NODE_ENV === 'production' ? personUrl : ""}/registration/${mostRecentResponse.id}`;

                    const data = await (await fetch(fetchingPersonUrl, {
                        credentials: "include",
                        signal
                    })).json();

                    console.log('debug skeleton loading loadingRejectCodes click results associations data: ', { data, forId: mostRecentResponse.id })

                    if (data) {
                        const { descriptors } = data;
                        console.log('debug skeleton loading loadingRejectCodes descriptiors: ', descriptors)
                        let notesObject = {
                            field60: descriptors.data.type2.field60,
                            field60IsObject: typeof descriptors.data.type2.field60 === "object" ? true : false
                        }
                        let transformedData;
                        console.log('descriptors.data.type2.field60: ', JSON.stringify(notesObject))
                        if (notesObject.field60IsObject) {
                            transformedData = notesObject.field60.map((obj: any, index: number) => { return transformRejectData(obj, index, notesObject.field60IsObject) });
                            console.log('debug skeleton loading loadingRejectCodes setting reject data: ', transformedData)
                            setRejectData(transformedData)
                            setTotalRejectCodes(transformedData.length)
                        } else {
                            console.log('debug skeleton loading loadingRejectCodes setting empty reject data ', notesObject)
                            transformedData = transformRejectData(notesObject.field60, 0, notesObject.field60IsObject)
                            setRejectData([transformedData])
                            setTotalRejectCodes([transformedData].length)
                        }

                    }

                } else {
                    setRejectData([])
                    setTotalRejectCodes(0)
                }


                return () => {
                    controller.abort("request cancelled");
                }

            } catch (err: any) {
                console.log('ERROR => ', err);
            }

        }

    }, [registrationId, adjudicationUrl, personUrl])

    return { resultsResponse, rejectData, setLoadingRejectCodes, loadingRejectCodes, totalRejectCodes };
};
